import React from "react";

import { setAdditionalInformation } from "@src/services/resourcePlanModalSlice";
import { useAppDispatch } from "@src/setupStore";
import { AdditionalInformation } from "@src/types";
import { Form, Input } from "antd";
import "./additional_information_form.less";

export interface AdditionalInformationFormProps {
  projectIdentifier: string;
  scope: string;
  specificRole: string;
}

const AdditionalInformationForm: React.FC<AdditionalInformationFormProps> = (
  props
) => {
  const [form] = Form.useForm<AdditionalInformation>();
  const dispatch = useAppDispatch();

  /**
   * The onValuesChange method which is called every time additional information was updated
   *
   * @param {AdditionalInformation} updatedAdditionalInformationFields - new updated additional information
   */
  function onValuesChange(
    __,
    updatedAdditionalInformationFields: AdditionalInformation
  ): void {
    dispatch(setAdditionalInformation(updatedAdditionalInformationFields));
  }

  return (
    <div className="additional-information-form">
      <Form
        form={form}
        layout="vertical"
        onValuesChange={onValuesChange}
        initialValues={{ ...props }}
      >
        <Form.Item name="projectIdentifier" label="Project identifier">
          <Input placeholder="Please add a project identifier" />
        </Form.Item>
        <Form.Item name="specificRole" label="Specific Role">
          <Input placeholder="Please add a specific role" />
        </Form.Item>
        <Form.Item name="scope" label="Scope">
          <Input placeholder="Please add a scope" />
        </Form.Item>
      </Form>
    </div>
  );
};

export default AdditionalInformationForm;
